import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import GLightbox from "glightbox";

export default function HeroFour() {
  const imageRef = useRef(null);
  const perspectiveValue = 20;

  useEffect(() => {
    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const scrollTop =
            window.scrollY || document.documentElement.scrollTop;

          if (imageRef.current) {
            imageRef.current.style.transform =
              scrollTop > 500
                ? "none"
                : `perspective(${
                    perspectiveValue + scrollTop / 2
                  }px) rotateX(1deg)`;
          }

          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const lightbox = GLightbox({
      selector: ".video-play-btn",
      touchNavigation: true,
      loop: false,
    });

    return () => {
      lightbox.destroy(); // Clean up on unmount
    };
  }, []);

  return (
    <section id="banner" className="w-full relative overflow-hidden">
      {/* Background video */}
      <video
        className="absolute top-0 left-0 w-full h-full object-cover z-0"
        autoPlay
        muted
        loop
        playsInline
      >
        <source src="/assets/videos/bg.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div
        style={{
          backgroundImage: "linear-gradient(#0a011900, #0A0119)",
          opacity: 1,
          position: "absolute",
          width: "100%",
          height: "100%",
        }}
      ></div>

      {/* Content overlay */}
      <div className="relative w-full hero-section-wrapper z-10 mb-10 md:mb-20">
        {/* Optional dark overlay for contrast */}
        <div className="\">
          <div className="flex justify-center mt-16 sm:mt-[130px] xl:mt-[247px]">
            <div className="text-center px-4">
              <h1 className="text-[52px] leading-[64px] sm:text-48 sm:leading-normal md:text-[75px] md:leading-[95px] font-semibold text-white mb-5 sm:mb-7 md:mb-[60px] max-w-[844px] mx-auto mt-[120px] lg:mt-[120px] xl:mt-0">
                <span className="text-purple">Impera</span>
                <br />
                Impact from Intelligent Automation.
              </h1>

              <p className="text-white text-sm sm:text-18 font-medium max-w-[750px] mx-auto mb-4 sm:mb-5 md:mb-[55px] px-2">
              We unlock real enterprise value from technology
              </p>

              <div className="flex justify-center mb-16 sm:mb-[100px]">
                <Link to="/contact">
                  <div className="home-two-btn-bg py-3.5 group h4_contact_bg w-fit border-transparent mt-2.5">
                    <span className="relative z-10 text-white text-pone transition duration-300 group-hover:text-purple font-inter">
                      Let's get started
                    </span>
                    <svg
                      className="relative z-10"
                      width="7"
                      height="12"
                      viewBox="0 0 7 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        className="transition-all duration-300 group-hover:stroke-purple"
                        d="M1.10254 10.5L4.89543 6.70711C5.22877 6.37377 5.39543 6.20711 5.39543 6C5.39543 5.79289 5.22877 5.62623 4.89543 5.29289L1.10254 1.5"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </Link>
              </div>

              {/* Banner Image with perspective effect */}
              <div
                className="hero-banner flex justify-center w-full xl:min-h-[730px]"
                style={{ display: "none" }}
              >
                <div className="relative img" ref={imageRef}>
                  <img
                    src="/assets/images/Container.png"
                    alt=""
                    className="relative z-10"
                  />
                  <div className="absolute -top-8 md:-top-[80px] left-0 w-full flex justify-center">
                    <img
                      src="/assets/images/home-four/hero-thumb-shadow.svg"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
